import { UploadFileAPI } from "@brg/api";
import { Voidable } from "@brg/toolbox";
import { useToasts } from "@brg/ui";
import { useSimpleUploader } from "@brg/uploader";
import { useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";

const useEmblemUploader = (teamId: string) => {
    const sipRef = useRef<any>(null);
    const toasts = useToasts();
    const { i18n: { language } } = useTranslation();

    const uploaderCallback = useCallback((fileId: Voidable<string>) => {
        if (!fileId) {
            return null;
        }
        UploadFileAPI.Upload({
            fileId,
            profileId: teamId,
            service: 'geography',
            entityType: 'geographyteamavatar',
            localization: language
        }).then((res) => {
            sipRef.current.uploader.uploader.uppy.reset();
            window.location.reload();
            return res;
        });
    }, [teamId, language])

    const uploadValidator = useCallback(async (files: any) => {
        let failedChecks: {
            dimensions?: boolean;
            size?: boolean;
            ratio?: boolean;
            type?: boolean;
        } = {};
        const loadFile = () => new Promise((resolve, reject) => {
            const fr = new FileReader();
            fr.onload = function () { // file is loaded
                const img = new Image();

                img.onload = function () {
                    const {
                        width,
                        height,
                    } = img;
                    resolve({
                        width,
                        height,
                    })
                };

                //@ts-ignore
                img.src = fr.result; // is the data URL because called with readAsDataURL
            };
            fr.readAsDataURL(files[0]);
        })

        if (!['image/jpeg'].includes(files?.[0]?.type)) {
            toasts.error('Допустимые форматы: jpg');
            failedChecks.size = true;
        }

        const {
            size: failedSize,
            dimensions: failedDimensions,
            ratio: failedRatio,
        } = failedChecks;

        if (failedSize || failedDimensions || failedRatio) {
            sipRef.current.uploader.inputRef.current.value = '';

            return false;
        }

        return true;
    }, []);

    const fileInput = useSimpleUploader(uploaderCallback, uploadValidator);
    sipRef.current = fileInput;

    return fileInput;
}

export default useEmblemUploader;import { UploadFileAPI } from "@brg/api";
import { Voidable } from "@brg/toolbox";
import { useToasts } from "@brg/ui";
import { useSimpleUploader } from "@brg/uploader";
import { useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";

const useEmblemUploader = (teamId: string) => {
    const sipRef = useRef<any>(null);
    const toasts = useToasts();
    const { i18n: { language } } = useTranslation();

    const uploaderCallback = useCallback((fileId: Voidable<string>) => {
        if (!fileId) {
            return null;
        }
        UploadFileAPI.Upload({
            fileId,
            profileId: teamId,
            service: 'geography',
            entityType: 'geographyteamavatar',
            localization: language
        }).then((res) => {
            sipRef.current.uploader.uploader.uppy.reset();
            window.location.reload();
            return res;
        });
    }, [teamId, language])

    const uploadValidator = useCallback(async (files: any) => {
        let failedChecks: {
            dimensions?: boolean;
            size?: boolean;
            ratio?: boolean;
            type?: boolean;
        } = {};
        const loadFile = () => new Promise((resolve, reject) => {
            const fr = new FileReader();
            fr.onload = function () { // file is loaded
                const img = new Image();

                img.onload = function () {
                    const {
                        width,
                        height,
                    } = img;
                    resolve({
                        width,
                        height,
                    })
                };

                //@ts-ignore
                img.src = fr.result; // is the data URL because called with readAsDataURL
            };
            fr.readAsDataURL(files[0]);
        })

        if (!['image/jpeg'].includes(files?.[0]?.type)) {
            toasts.error('Допустимые форматы: jpg');
            failedChecks.size = true;
        }

        const {
            size: failedSize,
            dimensions: failedDimensions,
            ratio: failedRatio,
        } = failedChecks;

        if (failedSize || failedDimensions || failedRatio) {
            sipRef.current.uploader.inputRef.current.value = '';

            return false;
        }

        return true;
    }, []);

    const fileInput = useSimpleUploader(uploaderCallback, uploadValidator);
    sipRef.current = fileInput;

    return fileInput;
}

export default useEmblemUploader;